module.exports = __webpack_public_path__ + "img/jasrac-mark.bf8cbc3f.png";